import { Component, input } from '@angular/core';

@Component({
  selector: 'app-metadata-cell',
  templateUrl: './metadata-cell.component.html',
  styleUrls: ['../crawled-document-metadata.component.scss'],
})
export class MetadataCellComponent {
}
